import { createTheme } from '@mui/material/styles'

import { palette as basePalette, buildPalette, hexToRgba } from './palette'
import { typography } from './typography'
import { breakpoints } from './spacing'
import { createComponents } from './components'

// Factory to create an app theme for a given primary hex
export const createAppTheme = (primaryHex = basePalette.primary.main) => {
  const dynamicPalette = buildPalette(primaryHex)
  const components = createComponents(dynamicPalette)

  return createTheme({
    palette: dynamicPalette,
    typography,
    breakpoints,
    components,
  })
}

export const theme = createAppTheme()
export {
  basePalette as palette,
  typography,
  breakpoints,
  createComponents,
  hexToRgba,
}

export const THEME_COLOR_OPTIONS = [
  { id: '#CB5E3C', name: 'Forcyte' },
  { id: '#00ae9b', name: 'Suncoast' },
  { id: '#b5121b', name: 'RRVBC' },
  { id: '#5298d2', name: 'Ozark' },
  { id: '#2E7D32', name: 'Green' },
  { id: '#1976D2', name: 'Blue' },
  { id: '#6A1B9A', name: 'Purple' },
  { id: '#D32F2F', name: 'Red' },
  { id: '#ED6C02', name: 'Orange' },
  { id: '#00897B', name: 'Teal' },
]
